<template>
  <div class="content-wrap">
    <section>
      <h1>ミツカル プライバシーポリシー</h1>
      <p>ケイアイスター不動産グループ（ケイアイスター不動産株式会社 および そのグループ子会社。以下「当グループ」といいます。）は、お客様から寄せられる信用・信頼はかけがえのない財産であると認識し、当グループが適正に取得したお客様の個人情報（氏名・住所・電話番号・メールアドレスなど、特定の個人を識別できる情報）については、関連する法令ならびにガイドラインを遵守し適切に取り扱い、保護することが当グループの事業活動の基本であるとともに社会的責務であると考え、以下のとおり「個人情報保護方針」を定め、当グループの基本姿勢を宣言します。</p>
      <h3>１．基本姿勢</h3>
      <p>当グループは、個人情報保護に関して社内規程及び管理体制を定め、教育訓練・安全対策を実施して個人情報の厳重な管理を行います。</p>
      <h3>２．個人情報の取得ならびに利用目的</h3>
      <p>当グループが、個人情報を取得する際には利用目的を特定し、当グループホームページに公表又は本人に明示したうえで、目的達成に必要な範囲で取得させていただきます。</p>
      <h3>３．第三者への開示・提供の禁止</h3>
      <p>当グループは、適正に取得したお客様の個人情報について、当グループホームページに公表しているいずれかの場合を除き、いかなる第三者にも開示・提供いたしません。</p>
      <h3>４．業務委託先への義務付け</h3>
      <p>当グループが上記３に基づき個人情報を提供する第三者には、当グループと同様の水準で個人情報の厳重な管理を徹底するよう契約により義務付け、これを実施させます。</p>
      <h3>５．個人情報保護マネジメントシステムの確立</h3>
      <p>当グループは、個人情報保護マネジメントシステム（方針・規程・体制を整備し、運用・点検・見直しを行うマネジメントシステム）を確立し、適用される法令、規範を遵守するとともに、お客様の個人情報の保護をさらに徹底します。</p>
    </section>
    <section>
      <h2>個人情報の取り扱い</h2>
      <p>当グループでは、当ウェブサイトのご利用ならびに営業活動等にてお客様からご提供いただいた個人情報及び当グループが適正に取得したお客様の個人情報の取扱いに関する方針を定め、個人情報の適正な管理・利用と保護に努めることで、お客様の個人情報を守り、その信頼に応えます。</p>
      <h3>１．個人情報</h3>
      <p>個人情報とは、ご利用者の氏名、住所、電話番号、電子メールアドレスその他の記述により、個人を特定できる固有の情報のことです。また、その情報のみでは識別できない場合でも、他の情報と容易に照合でき、結果的に個人を識別できるものも個人情報に含まれます。</p>
      <h3>２．個人情報の利用目的</h3>
      <ul>
        当グループが適正に取得したお客様の個人情報については、以下の事業目的の範囲内において利用させていただきます。
        <li>（１）商品・サービス提供に関する各種手続き（融資・許認可取得・登記等）のため</li>
        <li>（２）営業活動におけるアンケートの調査ならびに資料、案内送付のため</li>
        <li>（３）住宅プランの提供及びそれに関連する必要な調査実施のため</li>
        <li>（４）売買契約、工事請負契約、その他の契約の準備、締結ならびに履行のため</li>
        <li>（５）アフターサービスおよびメンテナンス等の対応のため</li>
        <li>（６）各種保険の代理業のため</li>
        <li>（７）当社の提携先企業が取り扱う商品またはサービスに関する情報を提供するため</li>
        <li>（８）上記に付帯する事項実施のため</li>
      </ul>
      <h3>３．個人情報・提供の禁止</h3>
      <ul>
        当グループが適正に取得したお客様の個人情報については、以下の場合を除き、本人の許可なく第三者への開示・提供はいたしません。
        <li>（１）法令等により開示を求められた場合</li>
        <li>（２）ご利用者の事前の合意・承諾を得た場合</li>
        <li>（３）当グループとの間で秘密保持に関する契約を締結している会社に対し、当グループのサービスを遂行する上で必要な情報を提供する場合</li>
        <li>（４）個人の特定が不可能な状態で個人情報を提供する場合</li>
        <li>（５）ご利用者および公衆の生命、身体または財産の保護のために必要がある場合であって、利用者の同意を得ることが困難であるとき</li>
        <li>（６）下記４の内容に基づくとき</li>
      </ul>
      <h3>４．個人データの第三者への提供</h3>
      <ul>
        当グループは上記２の利用目的の達成に必要な範囲で、以下のとおり個人データを第三者に提供する場合があります。 なお、ご本人からの申し出がされた場合は、第三者への提供は停止します。
        <li>
          （１）提供する第三者
          <ul>
            <li>① 不動産売買・賃貸の仲介における契約相手方となる者、その見込者</li>
            <li>② 他の宅地建物取引業者、インターネット広告掲載業者・不動産事業者団体</li>
            <li>③ 指定流通機構（物件登録、成約通知および同機構のデータを利用しての営業、価格査定等の実施）</li>
            <li>④ 新規物件の販売における事業主・共同代理会社・媒介会社</li>
            <li>⑤ 不動産売買・賃貸の仲介におけるお客様を紹介した宅建業者・代理会社・媒介会社</li>
            <li>⑥ 不動産取引の付帯業務における金融機関、司法書士、土地家屋調査士、不動産管理業者、 リフォーム業者、引越し業者等</li>
            <li>⑦ 当社の提携先企業（家具・インテリア・太陽光パネルなどのオプション商品を販売する会社など）</li>
            <li>⑧ その他、上記２の利用目的の達成に必要な範囲の相手先</li>
          </ul>
        </li>
        <li>
          （２）提供される個人データの項目
          <br />氏名、住所、電話番号（携帯電話を含む）、ＦＡＸ番号、電子メールアドレス、勤務先（役職・部署を含む）、成約情報等その他利用目的に必要な範囲の項目
        </li>
        <li>
          （３）第三者への提供の方法
          <br />書面または電子情報による。
        </li>
      </ul>
      <h3>５．個人情報の共同利用について</h3>
      <ul>
        当グループは、以下のとおり個人情報を共同利用いたします。 なお、ご本人からの申し出がされた場合は、第三者への提供は停止します。
        <li>
          （１）共同利用する個人情報の内容
          <br />お問い合わせ、ご相談、ご要望、ご指摘等を頂いたお客様の氏名、住所、電話番号（携帯電話を含む）、ＦＡＸ番号、電子メールアドレス、勤務先（役職・部署を含む）、成約情報等その他利用目的に必要な範囲の項目
        </li>
        <li>
          （２）共同利用する目的
          <ul>
            <li>① 商品・サービス提供に関する各種手続き（融資・許認可取得・登記等）のため</li>
            <li>② 営業活動におけるアンケートの調査ならびに資料、案内送付のため</li>
            <li>③ 住宅プランの提供及びそれに関連する必要な調査実施のため</li>
            <li>④ 売買契約、工事請負契約、その他の契約の準備、締結ならびに履行のため</li>
            <li>⑤ アフターサービスおよびメンテナンス等の対応のため</li>
            <li>⑥ 各種保険の代理業のため</li>
            <li>⑦ 上記に付帯する事項実施のため</li>
          </ul>
        </li>
        <li>
          （３）共同利用する者の範囲
          <br />以下の①～⑰のケイアイスター不動産のグループ会社
          <ul>
            <li>① ケイアイスターデベロップメント株式会社</li>
            <li>② ケイアイクラフト株式会社</li>
            <li>③ ケイアイスタービルド株式会社</li>
            <li>④ ケイアイネットリアルティ１ｓｔ株式会社</li>
            <li>⑤ ケイアイネットリアルティ２ｎｄ株式会社</li>
            <li>⑥ ケイアイネットリアルティ３ｒｄ株式会社</li>
            <li>⑦ ケイアイネットクラウド株式会社</li>
            <li>⑧ カイマッセ不動産株式会社</li>
            <li>⑨ ケイアイプランニング株式会社</li>
            <li>⑩ 株式会社よかタウン</li>
            <li>⑪ 株式会社旭ハウジング</li>
            <li>⑫ 株式会社フレスコ</li>
            <li>⑬ 株式会社建新</li>
            <li>⑭ BRエステート株式会社</li>
            <li>⑮ 株式会社ハウスライン</li>
            <li>⑯ KSキャリア株式会社</li>
            <li>⑰ TOKYO BIG HOUSE株式会社</li>
          </ul>
        </li>
      </ul>
      <h3>６．匿名加工情報の取り扱い</h3>
      <ul>
        当グループは、以下のとおり匿名加工情報（お客様の個人情報から、お客様を識別することができないよう加工したもの）を継続的に作成し、第三者に提供しています。
        <li>
          （１）匿名加工情報に含まれる個人に関する情報の項目
          <ul>
            <li>・性別</li>
            <li>・生年</li>
            <li>・購買履歴</li>
          </ul>
        </li>
        <li>
          （２）提供する情報に含まれる個人に関する情報の項目
          <ul>
            <li>・性別</li>
            <li>・生年</li>
            <li>・購買履歴</li>
          </ul>
        </li>
        <li>
          （３）提供方法
          <ul>
            <li>・第三者が匿名加工情報を利用できるようサーバにアップロード</li>
          </ul>
        </li>
      </ul>
      <p>当グループは、匿名加工情報についても、安全管理のための措置を講じます。</p>
      <h3>７．お客様ご本人からの開示請求</h3>当グループは、ご本人からの個人情報の開示を求められたときは、ご本人に対し、法令等に定める手続きに従い開示します。 ただし、開示することにより、次のいずれかに該当する場合は、その全部又は一部を開示しない場合があります。
      <ul>
        <li>（１）ご本人または第三者の生命、身体、財産その他の権利・利益を害する恐れがある場合</li>
        <li>（２）当グループの業務の適正な実施に著しい支障を及ぼすおそれがある場合</li>
        <li>（３）他の法令に違反することとなる場合</li>
      </ul>
      <h3>８．当ウェブサイトによる個人情報の取得</h3>
      <p>当ウェブサイトでは、資料請求等において、お客様が必要事項を入力することにより、その個人情報をお預かりいたします。</p>
      <h3>９．個人情報の管理およびセキュリティ</h3>
      <p>当グループでは、お客様からご提供いただいた個人情報及び当グループが適正に取得したお客様の個人情報については、紛失、改ざん、漏洩等のないよう厳重に管理いたします。また個人情報を扱う社員に対し、教育啓蒙活動を継続的に実施し、基本方針の遵守状況を定期的に監査し、適性管理の維持向上に努めます。</p>
      <h3>１０．クッキー（Cookies）について</h3>
      <p>当ウェブサイトでは、ご利用者にカスタマイズされたサービスをご提供するためにクッキー※を使用させていただく場合があります。 ※クッキーはご利用者が当ウェブサイトに再度訪問された際、より便利に当サイトを閲覧していただくためのものであり、ご利用者のプライバシーを侵害するものではなく、またご利用者のコンピューターへ悪影響を及ぼすことはありません。</p>
      <h3>１１．プライバシーポリシーの改訂</h3>
      <p>当ウェブサイトでは、個人情報の取り扱いに関する文書の一部または全部を改訂することがあります。個人情報を取得した時点で当文書に記述していたものと異なる方法で個人情報を使用する場合には、ご利用者の皆様にご連絡いたします。</p>
      <h3>１２．個人情報に関する相談窓口</h3>
      <p>
        ケイアイスター不動産 総務部 TEL 0120-08-5512
        <br />制定 平成17年2月1日 改定 平成29年10月1日
      </p>
    </section>
  </div>
</template>

<script>
import IsMobileMixin from '@/plugins/isMobile';

export default {
  name: 'StaticContentsPrivacyPolicy',
  mixins: [IsMobileMixin],
  data() {
    return {};
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss">
@charset "UTF-8";
h1 {
  font-family: "メイリオ", "Meiryo", sans-serif;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 27px;
}
h2 {
  font-size: 18px;
  font-weight: bold;
  padding: 17px 0 20px;
  text-align: center;
  background-color: #f6f6f6;
  margin-bottom: 20px;
  margin-top: 40px;
}
h3 {
  margin-bottom: 9px;
  font-size: 14px;
  font-weight: bold;
  margin-top: 27px;
}
p {
  font-size: 14px;
  margin-bottom: 27px;
}
.content-wrap {
  line-height: 1.6em;
}
.breadcrumb {
  margin-bottom: 22px;
  margin-left: 41px;
  color: #707070;
}
.breadcrumb a {
  color: #e83532;
  text-decoration: none;
  font-size: 12px;
}
.align-center {
  text-align: center;
  margin-bottom: 31px;
}
.to-the-top {
  text-align: center;
  color: #666666;
  background-color: #fff;
  border: #707070 1px solid;
  border-radius: 100vh;
  padding: 13px 60px;
  text-decoration: none;
  display: none;
}

@media screen and (max-width: 639px) {
  body {
    background-color: #ffffff;
    padding-top: 0;
  }
  .breadcrumb {
    margin: 0 14px 34px;
  }
  .to-the-top {
    display: initial;
  }
}
</style>
